import React from 'react'

import { FadeIn, HeadingSmall, HeadingMedium, HeadingLarge, BodyText } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'

import StyleboardNotification from 'features/Styleboard/styleboard-overview/components/StyleboardNotification'
import { NotificationType } from 'features/Styleboard/types'

import styles from './StyleboardsError.scss'

interface Error {
  titleSize?: 'large' | 'medium' | 'small'
  variation?: 'styleboards' | 'following' | 'favourites'
}

export type ErrorProps = Error

const StyleboardsError: React.FC<ErrorProps> = ({
  titleSize = 'large',
  variation = 'styleboards',
}) => {
  const isSmall = titleSize === 'small'
  const isMedium = titleSize === 'medium'

  const heading = (): React.ReactNode => {
    if (isSmall) {
      return (
        <HeadingSmall Tag="h3" className={styles.errorText}>
          {getLabelFromStorage('mycloset.error.title')}
        </HeadingSmall>
      )
    }
    if (isMedium) {
      return (
        <HeadingMedium Tag="h3" className={styles.errorText}>
          {getLabelFromStorage('mycloset.error.title')}
        </HeadingMedium>
      )
    }
    return (
      <HeadingLarge Tag="h2" className={styles.errorText}>
        {getLabelFromStorage('mycloset.error.title')}
      </HeadingLarge>
    )
  }

  const error =
    variation === 'styleboards'
      ? [NotificationType.FETCH_STYLEBOARDS_FAILED]
      : [
          NotificationType.FOLLOW_STYLEBOARD_FAILED,
          NotificationType.FETCH_FOLLOW_STYLEBOARDS_FAILED,
        ]

  return (
    <FadeIn>
      {heading()}
      <BodyText className={styles.errorText}>
        {getLabelFromStorage('mycloset.error.description')}
      </BodyText>
      <StyleboardNotification width="fullWidth" includeNotifications={error} />
    </FadeIn>
  )
}

export default StyleboardsError
